/* eslint-disable @typescript-eslint/no-explicit-any */
import Wix from './wix-sdk-polyfill';
import { mergeComponentSetting, mergeComponentSettingInStore } from '../actions/settings';
import { getAppComponent, getIsDemoMode } from '../state/site/selectors';
import { VIEW_MODE_EDITOR } from '../constants/view-modes';

export default function listenToStyleParamsChange(store: any, viewMode: string) {
  Wix.addEventListener(Wix.Events.STYLE_PARAMS_CHANGE, (styleParams: any) => {
    const state = store.getState();

    if (getIsDemoMode(state)) {
      return;
    }

    if (viewMode === VIEW_MODE_EDITOR) {
      const appComponent = getAppComponent(state);
      const compId = Wix.Utils.getCompId();
      store.dispatch(mergeComponentSetting(appComponent, compId, viewMode, { styleParams }));
    } else {
      store.dispatch(mergeComponentSettingInStore({ styleParams }));
    }
  });
}
